import { render, staticRenderFns } from "./PopupTicket.vue?vue&type=template&id=5480901d"
import script from "./PopupTicket.vue?vue&type=script&lang=js"
export * from "./PopupTicket.vue?vue&type=script&lang=js"
import style0 from "./PopupTicket.vue?vue&type=style&index=0&id=5480901d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports